export interface IBuilder<T> {
    build(): T;
}

export interface IAsyncBuilder<T> {
    build(): Promise<T>;
}
